/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs */



/**
* | output |
* | --- |
* | "Keyboard Shortcuts" |
*
* @param {Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_keyboard_shortcuts_title = /** @type {((inputs?: Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Keyboard_Shortcuts_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourcis Clavier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tastenkombinationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scorciatoie da tastiera")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Клавиатурные сочетания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atajos de teclado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("键盘快捷键")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キーボードショートカット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजीपटल अल्प मार्ग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalhos de teclado")
	return /** @type {LocalizedString} */ ("Keyboard Shortcuts")
});